'use client';

import { useBooking } from '../context/BookingContext';
import { ServiceSelection } from './steps/ServiceSelection';
import { PlaceSelection } from './steps/PlaceSelection';
import { ZoneAddressStep } from './steps/ZoneAddressStep';
import { QuoteRequestStep } from './steps/QuoteRequestStep';
import { AvailabilityPicker } from './steps/AvailabilityPicker';
import { CheckoutStep } from './steps/CheckoutStep';
import { BookingSuccess } from './steps/BookingSuccess';

export function BookingStepRenderer() {
  const { currentStep, ctx, labels, retryLoad, backToSiteUrl } = useBooking();

  if (currentStep === 'success') return <BookingSuccess />;

  /* Chargement du catalogue en échec : on réessaie sans recharger la page (bug 22). */
  if (currentStep === 'error') {
    return (
      <div className="bt-step">
        <div className="bt-error bt-error--load" role="alert">
          <p className="bt-error__message">{ctx.error ?? labels.load_error}</p>
          <button type="button" className="bt-cta bt-cta--small bt-cta--secondary" onClick={retryLoad}>
            {labels.retry}
          </button>
          {/* Plein écran mobile du site : le menu est masqué, ce lien est la sortie. */}
          {backToSiteUrl ? (
            <a className="bt-progress__site-link" href={backToSiteUrl}>
              {labels.back_to_site}
            </a>
          ) : null}
        </div>
      </div>
    );
  }

  if (currentStep === 'loading' || ctx.dataLoading) {
    return (
      <div className="bt-step">
        <div className="bt-loading">
          <div className="bt-spinner" />
        </div>
      </div>
    );
  }

  switch (currentStep) {
    case 'services':
      return <ServiceSelection />;
    case 'place':
      return <PlaceSelection />;
    case 'zone_address':
      return <ZoneAddressStep />;
    case 'slot':
      return <AvailabilityPicker />;
    case 'checkout':
      return <CheckoutStep />;
    case 'quote':
      return <QuoteRequestStep />;
    default:
      return null;
  }
}
